/* eslint-disable no-case-declarations */
import {
  CREATE_SIGNAL_ALERT_FORM_CLEAR,
  CREATE_SIGNAL_ALERT_FORM_EDIT,
  CREATE_SIGNAL_ALERT_SAVE_ERROR,
  CREATE_SIGNAL_ALERT_SAVE_REQUEST,
  CREATE_SIGNAL_ALERT_SAVE_SUCCESS,
} from '../../../constants/ActionTypes';
import { combineReducers } from 'redux';

function getDefaultdata() {
  return {
    maxEntryCount: 1,
  };
}

const create = (
  state = {
    data: getDefaultdata(),
    loading: false,
    isFetching: false,
    updateTime: new Date(),
  },
  action
) => {
  switch (action.type) {
    case CREATE_SIGNAL_ALERT_FORM_EDIT:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        updatedAt: new Date(),
      };
    case CREATE_SIGNAL_ALERT_FORM_CLEAR:
      return {
        ...state,
        data: getDefaultdata(),
        result: {},
        updatedAt: new Date(),
      };
    default:
      return state;
  }
};

const createResposne = (
  state = {
    data: {},
    isFetching: false,
    error: null,
    updateTime: new Date(),
  },
  action
) => {
  switch (action.type) {
    case CREATE_SIGNAL_ALERT_FORM_CLEAR:
      return {
        ...state,
        data: {},
        updatedAt: new Date(),
      };
    case CREATE_SIGNAL_ALERT_SAVE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case CREATE_SIGNAL_ALERT_SAVE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.data.data,
      };
    case CREATE_SIGNAL_ALERT_SAVE_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

const signalAlerts = combineReducers({
  create,
  createResposne,
});

export default signalAlerts;
